import React from 'react'
import Layout from 'shared/layouts/Main'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import { eulaLocation } from 'consts'
import { Button } from 'react-bootstrap'
import acceptEula from './utils/acceptEula'

const Eula: React.FunctionComponent = () => {

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      pageTitle='EULA'
    >
      <>
        <br/>
        <p>Please accept the End User License Agreement to continue.</p>
        <br/>
        <iframe src={eulaLocation} style={{width: '100%', height: '80vh'}}></iframe>
        <br/>
        <br/>
        <div style={{textAlign: 'center'}}>
        <p>By selecting "Accept", you hereby accept the End User License Agreement.</p>
        <Button
          type='submit'
          name='save'
          className='btn-round btn-primary'
          onClick={() => {
            acceptEula()
          }}
          style={{marginRight: '16px'}}
        >
          Accept
        </Button>
        <Button
          type='submit'
          name='save'
          className='btn-round btn-secondary'
          onClick={() => {
            alert('EULA Declined.')
          }}
        >
          Decline
        </Button>
        </div>
      </>
    </Layout>
  )
}

export default Eula
